import { InjectionToken } from "@angular/core";

export const AVAILABLE_LOCALES = new InjectionToken<string[]>("AVAILABLE_LOCALES");

export const localesProvider = { provide: AVAILABLE_LOCALES, useValue: ["en-GB"] };
